import React from 'react'
import { format } from 'date-fns-tz'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { TextLink } from 'marketing-site/src/library/elements/TextLink'
import { Image } from 'marketing-site/src/library/elements/Image'
import { RichText } from 'marketing-site/src/library/elements/RichText'
import styles from './styles.scss'
import useTranslate from '../../hooks/useTranslate'

export function WebinarsDetails({
  title,
  subtitle,
  description,
  speakers,
  resources,
  isScheduled,
  isRecording,
  zoom,
  duration,
}: IProps): React.ReactElement {
  const { translate } = useTranslate()
  const dateOrDurationTitle = isScheduled ? 'Date/Time' : 'Duration'
  const dateOrDurationText =
    isScheduled && zoom ? format(zoom.startTimestamp, 'd LLLL h:mm bbbb z') : `${duration} min`

  return (
    <div className="webinar-details__wrapper">
      <div className="webinar-details">
        <div className="webinar-details__speakers">
          <div>
            <Text brand="default" size="eyebrows">
              {translate('Hosted By')}
            </Text>
          </div>
          {speakers.map((speaker) => {
            return (
              <div className="webinar-details__speaker" key={speaker.name}>
                {speaker.image && (
                  <div className="webinar-details__speaker--avatar">
                    <Image url={speaker.image} />
                  </div>
                )}
                <div className="webinar-details__speaker--info">
                  <div className="webinar-details__speaker--name">
                    <Text brand="default" size="caption-bold">
                      {speaker.name}
                    </Text>
                  </div>
                  {speaker.title && (
                    <div>
                      <Text brand="default" size="caption">
                        {speaker.title}
                      </Text>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
        {isScheduled || isRecording ? (
          <div className="webinar-details__datetime">
            <div className="webinar-details__datetime-title">
              <Text brand="default" size="eyebrows">
                {dateOrDurationTitle}
              </Text>
            </div>
            <div className="webinar-details__datetime-timestamp">
              <Text brand="default" size="body">
                {dateOrDurationText}
              </Text>
            </div>
          </div>
        ) : null}
        <div className="webinar-details__resources">
          <div className="webinar-details__resources-title">
            <Text brand="default" size="eyebrows">
              {translate('Resources')}
            </Text>
          </div>
          {resources.map((resource) => {
            return (
              <div className="webinar-details__resource" key={resource.label}>
                <TextLink url={resource.url}>
                  <Text brand="default" size="body">
                    {resource.label}
                  </Text>
                </TextLink>
              </div>
            )
          })}
        </div>
        <div className="webinar-details__main">
          <h2>
            <Text brand="default" size="heading-4">
              {title}
            </Text>
          </h2>
          <p>{subtitle}</p>
          <div className="webinar-details__main--description">
            {description && <RichText document={description} />}
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
